import { GraphQLTypes, InputType, Selector, $ } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';

export const GQL_CONFIRM_UPLOAD = typedGql('mutation')({
  confirmUpload: [
    { id: $('id', 'Int!'), status: $('status', 'Boolean!') },
    true,
  ],
});

const uploadPresignedUrl = Selector('UploadPreSignedUrl')({
  url: true,
  id: true,
});

export const GQL_PRESIGNED_URL = typedGql('mutation')({
  uploadPreSignedUrl: [
    { fileName: $('fileName', 'String!'), mimeType: $('mimeType', 'String!') },
    uploadPresignedUrl,
  ],
});

export type StoredUploadPresignedUrl = InputType<
  GraphQLTypes['UploadPreSignedUrl'],
  typeof uploadPresignedUrl
>;

const downloadFile = Selector('DownloadFile')({
  buffer: true,
  fileMimeType: true,
  fileName: true,
});

export const GQL_DOWNLOAD = typedGql('query')({
  downloadFile: [{ eTag: $('eTag', 'String!') }, { ...downloadFile }],
});

export type StoredDownload = InputType<
  GraphQLTypes['DownloadFile'],
  typeof downloadFile
>;

const filesSelector = Selector('MyFiles')({
  eTag: true,
  createdAt: true,
  fileMimeType: true,
  fileName: true,
});

export const GQL_ALL_MY_FILES = typedGql('query', { scalars })({
  getAllMyFiles: {
    ...filesSelector,
  },
});

export type StoredFiles = InputType<
  GraphQLTypes['MyFiles'],
  typeof filesSelector
>;
